import React from 'react';
import {Outlet} from 'react-router-dom';

const OtherPage = () => {
    return (
        <div>
            <h1>OtherPage</h1>
            <Outlet />
        </div>
    );
}

export default OtherPage;

